import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '@/auth/guard';
import DashboardLayout from '@/layouts/management';
import { SplashScreen } from '@/components/feedback/loading-screen';
import { OauthCallbackPage } from '@/pages/auth/oauth/oauthCallback';
import { accountsRoutes } from './accounts';
import { portfolioRoutes } from './portfolio';
import { reportsRoutes } from './reports';
import { directoryRoutes } from './directory';
import { settingsRoutes } from './settings';
import { marketingRoutes } from './marketing';
import { cloudCompassRoutes } from '../cloud';

export const managementRoutes = [
  {
    path: 'login',
    element: <Outlet />,
    children: [
      {
        path: 'oauth',
        element: <OauthCallbackPage />,
      },
    ],
  },
  {
    path: 'management',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      ...accountsRoutes,
      ...reportsRoutes,
      ...portfolioRoutes,
      ...directoryRoutes,
      ...marketingRoutes,
      ...settingsRoutes,
    ],
  },
  ...cloudCompassRoutes,
];
